import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import axios from 'axios';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { fuseAnimations } from '@fuse/animations';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { Configuration } from 'app/app.configuration';
import { DataService } from 'app/shared/common/helper/http-service';

@Component({
  selector: 'app-project-enquiry',
  templateUrl: './project-enquiry.component.html',
  styleUrls: ['./project-enquiry.component.scss'],
  animations: fuseAnimations
})

export class ProjectEnquiryComponent implements OnInit {

  panelOpenState = false;
  enquiryForm: FormGroup;
  actionForm: FormGroup;
  wonForm: FormGroup;
  empRole = '';
  reportingToDD = [];
  reportingList = [];
  reportingToOptions = [];
  showButton: boolean = false;
  newDate = Date.now();
  show: boolean = true;
  isEdit: boolean = true;
  actions = [];
  assigneesIdGet = [];
  assignedName = []
  actionDetails = [];
  versions = [];
  apiUrl: any;
  enquiryDocuments = [];
  opportunityEstimateDocument = [];
  profileId: any;
  commentData = [];
  documentUploadUrl = [];
  objectId = '';
  selectVersion: any;
  reporterId: any;
  isDisabled: boolean = false;
  versionNew: any;
  enquiryResult = [];
  documentDetails = [];
  cardId: any;
  versionId: any;
  disableEdit: boolean = false;
  arrayComments: any;
  showComment: boolean;
  today = new Date();
  activities = [];
  domains = [];
  opportunityType = [];
  enquiryStatus = [];
  opportunitySize = [];
  opportunityPercentage = [];
  estimateTemplate = [];
  technologies = [];
  queryData = [];
  riskData = [];
  queryForm: FormGroup;
  riskForm: FormGroup;
  currentUser: any;
  firstname: any;
  lastname: any;
  isDocumentEdit: boolean;
  dialogRef: any;
  clientList = [];
  oldAssignees: any;
  newAssignees = [];
  oldOpportunityValues: any;
  opportunityActivities = [];
  @ViewChild('uploadPopup', { static: false }) uploadPopup: TemplateRef<any>;
  @ViewChild('confirmationPopup', { static: false }) confirmationPopup: TemplateRef<any>;
  @ViewChild('wonPopup', { static: false }) wonPopup: TemplateRef<any>;
  @ViewChild('lostPopup', { static: false }) lostPopup: TemplateRef<any>;
  isConfirmation: any;
   

  constructor(
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    private parseService: ParseService,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration,
    private router: Router,
    private route: ActivatedRoute,
    private queryInterface: QueryInterface,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService,
    private getReportingToService: GetReportingToService,
    private dataService: DataService,
    private configuration: Configuration
  ) {

    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.currentUser = this.parseService.instance.User.current();
     

    this.enquiryForm = this._formBuilder.group({
      enquiryName: ['', Validators.required],
      clientName: ['', Validators.required],
      reporter: ['', Validators.required],
      requestedDate: ['', Validators.required],
      submittedDate: ['', Validators.required],
      status: ['', Validators.required],
      domain: ['', Validators.required],
      // estimateTemplate: ['', Validators.required],
      assignees: [''],
      referenceUrl: [''],
      designUrl: [''],
      opportunityType: [''],
      opportunitySize: [''],
      opportunityPercentage: [''],
      technologies: ['']
    });

    this.actionForm = this._formBuilder.group({
      version: ['', Validators.required],
      hours: ['', Validators.required],
      comments: ['']
    });

    this.wonForm = this._formBuilder.group({
      versionWon: ['', Validators.required],
      assigneeWon: ['', Validators.required],
    });

    this.queryForm = this._formBuilder.group({
      queries: [''],
    });

    this.riskForm = this._formBuilder.group({
      risk: [''],
    });

  }

  async ngOnInit() {

    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
        this.getEnquiryDetails();
      }
      else {
        this.isEdit = false;
      }
    });

    this.getReportingTo();
    this.getClient();

    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    await query.find().then(result => {
      this.apiUrl = result[0].get('apiUrl');
      this.enquiryStatus = result[0].get('opportunityStatus');
      this.opportunitySize = result[0].get('opportunitySize');
      this.opportunityPercentage = result[0].get('opportunityPercentage');
      this.opportunityType = result[0].get('opportunityType');
      this.estimateTemplate = result[0].get('estimateTemplate');
      this.technologies = result[0].get('technologies');
      this.domains = result[0].get('opportunityDomains');
    });

    if (this.isEdit == false) {
      this.enquiryForm.patchValue({
        reporter: this.profileId,
        requestedDate: new Date(),
        status: 'New'
      });
    }

  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  getEnquiryDetails() {
    this.enquiryDocuments = [];
    this.enquiryResult = [];

    let enquiryList = this.parseService.instance.Object.extend('Enquiry');
    let query = new this.parseService.instance.Query(enquiryList);
    query.include("requesterProfileId");
    query.include("client");
    query.equalTo('objectId', this.objectId);
    query.find().then(async results => {
      let result = results[0]
      let assignees = [];
      let assigneesId = [];
      let reporter = result.get('requesterProfileId').id;
      this.reporterId = result.get('requesterProfileId').id;
      let scopeDocument = result.get('scopeDocument');
      await this.getRelationsAssignee(result.get('assignees')).then(relationResult => {
        relationResult.forEach(async res => {
          assignees.push({
            id: res.id,
            username: res.get('username'),
            image: res.get('profileImageInfo').url
          });
          assigneesId.push(res.id);
          this.assigneesIdGet.push({ id: res.id, name: res.get('username') });

          await this.getDocuments(res).then(innerelement => {
            this.enquiryResult.push({
              name: res.get('firstName') + ' ' + res.get('lastName'),
              profileImageInfo: res.get('profileImageInfo').url,
              documents: innerelement
            });
          });
        });
      });
      if (this.profileId == reporter) {
        this.show = true;
        this.isDisabled = false;
        this.disableEdit = true;
      }
      else {
        this.show = false;
        this.isDisabled = true;
        this.disableEdit = false;
      }
      this.enquiryForm.patchValue({
        enquiryName: result.get('enquiryName'),
        clientName: result.get('client') ? result.get('client').id : '',
        reporter: result.get('requesterProfileId').id,
        assignees: assigneesId,
        requestedDate: result.get('requestedDate'),
        submittedDate: result.get('lastDateToSubmit'),
        status: result.get('status'),
        domain: result.get('domain')[0],
        referenceUrl: result.get('referenceUrl'),
        designUrl: result.get('designUrl'),
        // estimateTemplate: result.get('estimateTemplate'),
        opportunityPercentage: result.get('opportunityPercentage'),
        opportunitySize: result.get('opportunitySize'),
        opportunityType: result.get('opportunityType'),
        technologies: result.get('technologies')
      });

      this.opportunityActivities = result.get('activities');
      let activity = this.opportunityActivities;
      this.activities = activity.slice(0, 50);
      this.oldOpportunityValues = JSON.parse(JSON.stringify(this.enquiryForm.value));

      this.oldAssignees = assigneesId;
      this.enquiryDocuments = scopeDocument;
      this.queryData = result.get('queries');
      this.riskData = result.get('risk');
      this.getUploadedDocuments();
    });

  }

  async getRelationsAssignee(result) {
    var relationResult = [];
    await result
      .query()
      .each(function (obj) {
        relationResult.push(obj);
      });
    return relationResult;
  }

  createEnquiryDetails() {
    if (this.enquiryForm.valid) {
      let values = this.enquiryForm.value;
      let listOfDomains = [];
      let listOfAssignees = [];
      listOfDomains.push(values.domain);
      let scopeDocuments = this.enquiryDocuments;
      let enquiryClass = this.parseService.instance.Object.extend('Enquiry');
      var enquiryDetails = new enquiryClass();
      let requestedDate = (new Date(values.requestedDate));
      let submittedDate = (new Date(values.submittedDate));
      enquiryDetails.set('enquiryName', values.enquiryName);
      enquiryDetails.set('client', { __type: 'Pointer', className: 'Client', objectId: values.clientName });
      enquiryDetails.set('requestedDate', requestedDate);
      enquiryDetails.set('lastDateToSubmit', submittedDate);
      enquiryDetails.set('domain', listOfDomains);
      enquiryDetails.set('scopeDocument', scopeDocuments);
      enquiryDetails.set('opportunityType', values.opportunityType);
      enquiryDetails.set('opportunitySize', values.opportunitySize);
      enquiryDetails.set('opportunityPercentage', values.opportunityPercentage);
      enquiryDetails.set('referenceUrl', values.referenceUrl);
      enquiryDetails.set('designUrl', values.designUrl);
      // enquiryDetails.set('estimateTemplate', values.estimateTemplate);
      enquiryDetails.set('technologies', values.technologies ? values.technologies : []);
      enquiryDetails.set('queries', []);
      enquiryDetails.set('risk', []);

      enquiryDetails.set('requesterProfileId', { __type: 'Pointer', className: 'Profile', objectId: values.reporter });
      if (values.assignees.length > 0) {
        values.assignees.forEach(element => {
          var queryProfile = new this.parseService.instance.Object('Profile');
          queryProfile.id = element;
          var relation = enquiryDetails.relation('assignees');
          relation.add(queryProfile);
          listOfAssignees.push({
            name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
            email: queryProfile.get('email'),
            profilePic: queryProfile.get('profileImageInfo').url ? queryProfile.get('profileImageInfo').url :
              'https://naduvan.blob.core.windows.net/assets/1582806630024-e14de6cc-901c-4429-a193-a9e7d5748514.jpg'
          });
        });
      }
      enquiryDetails.set('status', values.assignees.length > 0 ? 'Waiting for estimate' : values.status);

      // Activities
      let activities = [];
      let message = 'Created a Opportunity ' + this.enquiryForm.value.enquiryName;
      let activity = this.activityCenterService.setActivityModel(message);
      activities.push(activity);
      enquiryDetails.set('activities', activities);
      // Activities

      enquiryDetails.save().then(async res => {
        this.toastr.success('Saved Successfully');
        this.router.navigate(['project-enquiry', { id: res.id }]);

        this.activityCenterService.createActivity(activities, this.hardCodedValues.opportunity, res.id);

        let datePipe = new DatePipe('en-US');
        let requester = new this.parseService.instance.Object('Profile');
        requester.id = res.get('requesterProfileId').objectId;

        let data = {
          opportunityName: res.get('enquiryName'),
          cutOffDate: datePipe.transform(res.get('lastDateToSubmit'), 'dd/MM/yyyy'),
          domain: res.get('domain')[0],
          requestedDate: datePipe.transform(res.get('requestedDate'), 'dd/MM/yyyy'),
          status: res.get('status'),
          requester: requester.get('firstName') + ' ' + requester.get('lastName'),
          assignees: listOfAssignees
        };
        this.dataService.add(this.configuration.opportunityAssigned, data).subscribe((data: any) => {
        });
      });
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  updateEnquiryDetails() {
    let domainArray = [];
    let scopeDocuments = [];
    scopeDocuments = this.enquiryDocuments;
    let enquiryValues = this.enquiryForm.value;
    domainArray.push(enquiryValues.domain);
    this.newAssignees = enquiryValues.assignees;

    let enquiryList = this.parseService.instance.Object.extend('Enquiry');
    let query = new this.parseService.instance.Query(enquiryList);
    query.equalTo('objectId', this.objectId);
    query.find().then(async results => {
      let result = results[0];
      if (this.oldAssignees != this.newAssignees) {
        this.oldAssignees.forEach(element => {
          var queryProfile = new this.parseService.instance.Object('Profile');
          queryProfile.id = element;
          var relation = result.relation('assignees');
          relation.remove(queryProfile);
        });
      }
      result.set('enquiryName', enquiryValues.enquiryName);
      result.set('client', { __type: 'Pointer', className: 'Client', objectId: enquiryValues.clientName });
      result.set('requestedDate', (new Date(enquiryValues.requestedDate)));
      result.set('lastDateToSubmit', (new Date(enquiryValues.submittedDate)));
      result.set('domain', domainArray);
      result.set('scopeDocument', scopeDocuments);
      result.set('opportunityType', enquiryValues.opportunityType);
      result.set('opportunitySize', enquiryValues.opportunitySize);
      result.set('opportunityPercentage', enquiryValues.opportunityPercentage);
      result.set('referenceUrl', enquiryValues.referenceUrl);
      result.set('designUrl', enquiryValues.designUrl);
      // result.set('estimateTemplate', enquiryValues.estimateTemplate);
      result.set('technologies', enquiryValues.technologies ? enquiryValues.technologies : []);

      result.set('requesterProfileId', { __type: 'Pointer', className: 'Profile', objectId: enquiryValues.reporter });
      if (enquiryValues.assignees.length > 0) {
        enquiryValues.assignees.forEach(element => {
          var queryProfile = new this.parseService.instance.Object('Profile');
          queryProfile.id = element;
          var relation = result.relation('assignees');
          relation.add(queryProfile);
        });
      }
      result.set('status', enquiryValues.assignees.length > 0 ? 'Waiting for estimate' : enquiryValues.status);

      // Activities
      let activities = await this.getActivity(this.oldOpportunityValues, enquiryValues);
      activities.forEach(element => {
        this.opportunityActivities.unshift(element);
      });
      result.set('activities', this.opportunityActivities);
      // let activityCenter = await this.activityCenterService.getActivity(enquiryValues, this.oldOpportunityValues, this.hardCodedValues.opportunity);
      this.activityCenterService.createActivity(activities, this.hardCodedValues.opportunity, this.objectId);
      // Activities

      result.save().then(res => {
        this.getEnquiryDetails();
        this.toastr.success('Updated Successfully');
      });
    });
  }

  /*
 ** ==========================================================
 ** Get activities
 ** ==========================================================
 */
  getActivity(oldValue, newValue): any[] {
    const activities = [];
    // tslint:disable-next-line: forin
    for (const oldproperty in oldValue) {
      for (const newproperty in newValue) {
        if (oldproperty === newproperty) {
          let activityModel = this.createActivity(oldproperty, oldValue[oldproperty], newValue[newproperty]);
          if (activityModel.allow) {
            if (activityModel.type === 'Array') {
              activityModel.activity.forEach(element => {
                activities.push(element);
              });

            } else {
              activities.push(activityModel.activity);
            }

          }
        }
      }
    }
    return activities;
  }

  /*
  ** ==========================================================
  ** Create activities
  ** ==========================================================
  */
  createActivity(property, oldValue, newValue): any {
    let message = '';
    let messages = [];
    let activity = {};
    let allow = false;
    const type = this.activityCenterService.typeCheck((property === 'submittedDate' || property === 'requestedDate') ? newValue._d : newValue);
    switch (type) {
      case 'string':
        if (oldValue !== newValue) {
          switch (property) {
            case 'clientName':
              const newClientName = this.clientList.filter(x => x.id === newValue);
              const oldClinetName = oldValue !== '' ? this.clientList.filter(x => x.id === oldValue) : '';
              // tslint:disable-next-line: max-line-length
              message = oldClinetName === '' ? 'Added a Client Name - ' + newClientName[0].name : 'Changed client name from ' + oldClinetName[0].name + ' to ' + newClientName[0].name;
              allow = true;
              break;
            case 'reporter':
              const oldReporting = oldValue !== '' ? this.reportingToDD.filter(x => x.id === oldValue) : '';
              const newReporting = this.reportingToDD.filter(x => x.id === newValue);
              if (newReporting.length > 0) {
                message = oldReporting.length === 0 ? 'Added a owner - ' + newReporting[0].name : 'Changed owner from ' + oldReporting[0].name + ' to ' + newReporting[0].name;
              }
              allow = true;
              break;
            default:
              const oldOpportunityName = oldValue !== '' ? oldValue : '';
              const newOpportunityName = newValue;
              let prop = this.hardCodedValues.getValues(property);
              message = oldOpportunityName === '' ? 'Added a ' + prop + ' - ' + newOpportunityName : 'Changed ' + prop + ' from ' + oldOpportunityName + ' to ' + newOpportunityName;
              allow = true;
              break;
          }
        }
        break;

      case 'Date':
        const datePipe = new DatePipe('en-US');
        const oldDate = datePipe.transform(oldValue, 'MMM dd yyyy');
        const newDate = datePipe.transform(newValue._d, 'MMM dd yyyy');
        let prop = this.hardCodedValues.getValues(property);
        if (oldDate !== newDate) {
          message = oldValue === '' ? 'Added a ' + prop : 'Updated the ' + prop + ' from ' + oldDate + ' to ' + newDate;
          allow = true;
        }
        break;

      case 'Array':
        let arrayProp = this.hardCodedValues.getValues(property);
        let arrayValue = [];
        arrayValue = this.activityCenterService.arrayDifference(oldValue, newValue);
        arrayValue.forEach(element => {
          const val1 = oldValue.includes(element);
          const val2 = newValue.includes(element);
          if (property == 'assignees') {
            var queryProfile = new this.parseService.instance.Object('Profile');
            queryProfile.id = element;
            messages.push(val1 === false && val2 === true ? 'Added a ' + arrayProp + ' - ' + queryProfile.get('firstName') + queryProfile.get('lastName')
              : 'Removed a ' + arrayProp + ' - ' + queryProfile.get('firstName') + queryProfile.get('lastName'));
          }
          else {
            messages.push(val1 === false && val2 === true ? 'Added a ' + arrayProp + ' - ' + element : 'Removed a ' + arrayProp + ' - ' + element);
          }
        });
        allow = true;
        break;
    }
    if (type === 'Array') {
      let act = [];
      messages.forEach(element => {
        act.push(this.activityCenterService.setActivityModel(element));
      });
      activity = act;
      return { activity: activity, allow, type };
    } else {
      activity = this.activityCenterService.setActivityModel(message);
      return { activity: activity, allow, type };
    }
  }

  async openFileUploadDialog(event): Promise<void> {
    this.opportunityEstimateDocument = [];
    this.cardId = event;
    if (this.cardId != '' && this.cardId != undefined) {
      this.isDocumentEdit = true;

      let enquiryAction = this.parseService.instance.Object.extend('EnquiryAction');
      let query = new this.parseService.instance.Query(enquiryAction);
      query.equalTo('objectId', this.cardId);
      query.find().then(results => {
        let result = results[0];
        let versions = result.get('version');
        let hour = result.get('hours');
        let comments = result.get('comments');
        let estimatedDocument = result.get('estimatedDocument');
        this.commentData = comments;
        this.actionForm.patchValue({
          version: versions,
          hours: hour,
        });
        this.opportunityEstimateDocument = estimatedDocument;
      });
    }
    else {
      this.actionForm.reset();
      this.isDocumentEdit = false;

      let enquiryAction = this.parseService.instance.Object.extend('EnquiryAction');
      let query = new this.parseService.instance.Query(enquiryAction);
      query.equalTo('enquiryId', { __type: 'Pointer', className: 'Enquiry', objectId: this.objectId });
      query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
      await query.find().then(results => {
        let result = results;
        this.actionForm.patchValue({
          version: String(result.length + 1),
        });
      });

    }
    this.dialog.open(this.uploadPopup, {
      width: '900px',
      height: '700px'
    });

  }

  updateFileUpload() {
    let enquiryAction = this.parseService.instance.Object.extend('EnquiryAction');
    let query = new this.parseService.instance.Query(enquiryAction);
    let actionValues = this.actionForm.value;
    let documents = this.opportunityEstimateDocument;
    query.equalTo('objectId', this.cardId);
    query.find().then(results => {
      let result = results[0];
      result.set('version', actionValues.version);
      result.set('hours', actionValues.hours);
      result.set('comments', this.commentData);
      result.set('estimatedDocument', documents);
      result.save().then(res => {
        this.toastr.success('Documents details updated successfully!!');
        this.actionForm.reset();
        this.getUploadedDocuments();
      });
      this.dialog.closeAll();
    });
  }

  confirmation(event) {
    this.isConfirmation = event.checked;
  }

  uploadDocument() {
    if (this.actionForm.valid) {
      let values = this.actionForm.value;
      let documents = this.opportunityEstimateDocument;
      let enquiryActionClass = this.parseService.instance.Object.extend('EnquiryAction');
      var reponseDetails = new enquiryActionClass();
      reponseDetails.set('enquiryId', { __type: 'Pointer', className: 'Enquiry', objectId: this.objectId });
      reponseDetails.set('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
      reponseDetails.set('version', values.version);
      reponseDetails.set('hours', values.hours);
      reponseDetails.set('comments', values.comments ? values.comments : []);
      reponseDetails.set('estimatedDocument', documents);
      reponseDetails.set('status', 'Posted');
      reponseDetails.save().then(res => {
        this.getUploadedDocuments();
        this.actionForm.reset();
      })
      this.toastr.success(' Saved Successfully!!');
      this.dialog.closeAll();
    }
    else {
      this.toastr.warning('Please enter all the fields');
    }
  }

  closeConfirmation() {
    this.dialogRef.close();
  }

  async getDocuments(element) {
    let documents = [];
    let userClass = this.parseService.instance.Object.extend('EnquiryAction');
    let query = new this.parseService.instance.Query(userClass);
    query.include('enquiryId');
    query.include('profileId');
    query.equalTo('enquiryId', { __type: 'Pointer', className: 'Enquiry', objectId: this.objectId });
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: element.id });
    await query.find().then(results => {
      results.forEach(element => {
        let datePipe = new DatePipe('en-US');
        let updatedAt = datePipe.transform(element.get('updatedAt'), 'MM/dd/yyyy');
        documents.push({
          id: element.id,
          version: element.get('version'),
          url: element.get('estimatedDocument'),
          hours: element.get('hours'),
          status: element.get('status'),
          updatedDate: updatedAt
        });
      });
    });
    return documents;
  }

  async getRelations(result) {
    var relationResult = [];
    await result.query().each(function (obj) {
      relationResult.push(obj);
    });
    return relationResult;
  }

  getUploadedDocuments() {
    this.documentDetails = [];
    let enquiryAction = this.parseService.instance.Object.extend('EnquiryAction');
    let query = new this.parseService.instance.Query(enquiryAction);
    query.include('enquiryId');
    query.equalTo('enquiryId', { __type: 'Pointer', className: 'Enquiry', objectId: this.objectId });
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    query.find().then(results => {
      results.forEach(element => {
        let datePipe = new DatePipe('en-US');
        let updatedAt = datePipe.transform(element.get('updatedAt'), 'MM/dd/yyyy');
        this.cardId = element.id;
        let updatedDate = updatedAt;
        this.documentDetails.push({
          id: element.id,
          status: element.get('status'),
          name: element.get('profileId').get('firstName') + ' ' + element.get('profileId').get('lastName'),
          version: element.get('version'),
          estimate: element.get('estimatedDocument'),
          updatedDate: updatedDate,
          hours: element.get('hours')
        });
      });
    });
  }

  addComment(value) {
    if (value != '') {
      let fName = this.parseService.instance.User.current().get('profile').get('firstName');
      let lName = this.parseService.instance.User.current().get('profile').get('lastName');
      if (this.show != true) {
        this.commentData.unshift({
          name: fName.concat(' ' + lName),
          comment: value,
          date: this.newDate
        });
      }
      if (this.show == true) {
        this.commentData.unshift({
          name: fName.concat(' ' + lName),
          comment: value,
          date: this.newDate
        });
      }
      this.actionForm.patchValue({
        comments: this.commentData,
      });
    }
    else {
      this.toastr.warning('Please enter the comments!!');
    }
  }

  fileUpload(event, type) {
    var formData = new FormData();
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file.type == 'application/pdf' || file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type == 'application/msword' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type == 'application/vnd.ms-excel') {
        formData.append('files', file);
        var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
        axios.post(this.apiUrl.mediaPath, formData, {
          headers: {
            // 'authorization': 'Bearer r:275fc76ef2168814a16b37a759eb538c',
            'authorization': 'Bearer ' + session,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(responseData => {
          let fileUrl = responseData.data.url
          var response = responseData;
          const name = response.data.url.split('/');
          if (type == 'srs') {
            this.enquiryDocuments.push({ id: response.data._id, name: name[4], url: response.data.url });
            this.updateEnquiryDetails();

            // Activities
            let activityNew = [];
            let message = ' Added a srs document ' + response.data.url;
            activityNew.push(this.activityCenterService.setActivityModel(message));
            activityNew.forEach(element => {
              this.opportunityActivities.unshift(element);
            });
            this.activityCenterService.createActivity(activityNew, this.hardCodedValues.opportunity, this.objectId);
            // Activities

          }
          if (type == 'plan') {
            this.opportunityEstimateDocument.push({ id: response.data._id, name: name[4], url: response.data.url });

            // Activities
            let activityNew = [];
            let message = ' Added a estimated document ' + response.data.url;
            activityNew.push(this.activityCenterService.setActivityModel(message));
            activityNew.forEach(element => {
              this.opportunityActivities.unshift(element);
            });
            var queryProfile = new this.parseService.instance.Object('Enquiry');
            queryProfile.id = this.objectId;
            queryProfile.set('activities', this.opportunityActivities);
            queryProfile.save();

            this.activityCenterService.createActivity(activityNew, this.hardCodedValues.opportunity, this.objectId);
            // Activities

          }
          this.toastr.success('File Uploaded Successfully!!');
        }).catch(err => {
          if (err.message == 'Network Error') {
            this.toastr.warning('Please upload Document, excel and Pdf files only');
          }
          if (err.response.data.message == 'Please upload the image less than 500kb') {
            this.toastr.warning('Please upload the file less than 500kb');
          }
        });
      }
      else {
        this.toastr.warning('Please upload Document, excel and Pdf files only');
      }
    }
  }

  /*
  ** ==========================================================
  ** Delete File
  ** ==========================================================
  */
  deleteFile(id, type) {
    const fileId = id;
    var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
    axios.delete(this.apiUrl.mediaPath + id, {
      headers: {
        "authorization": "Bearer " + session,
        // 'authorization': 'Bearer r:ce454e31d065189714ea31515f6372cf',
        'Content-Type': 'application/json'
      }
    }).then(aresf => {
      var response = aresf;
      let fileIndex;
      if (type == 'srs') {
        fileIndex = this.enquiryDocuments.findIndex(x => x.id == fileId);
        this.enquiryDocuments.splice(fileIndex, 1);
      } else if (type == 'plan') {
        fileIndex = this.opportunityEstimateDocument.findIndex(x => x.id == fileId);
        this.opportunityEstimateDocument.splice(fileIndex, 1);
      }
      this.updateEnquiryDetails();
    }).catch(err => {
      this.toastr.warning(err.response.data.message);
    });
  }

  backlocation() {
    this.router.navigate(['opportunity-list']);
  }

  closedwonPopup(): void {
    this.dialog.open(this.wonPopup, {
      width: '800px'
    });
  }

  closedLostPopup(): void {
    this.dialog.open(this.lostPopup, {
      width: '800px'
    });
  }

  close(): void {
    this.dialog.closeAll();
  }

  addQuery() {
    const createrProfile = this.currentUser.get('profile');
    const createrImg = createrProfile.get('profileImageInfo').url;
    let queryValue = this.queryForm.value.queries;
    if (queryValue != '') {
      this.queryData.unshift({
        name: this.firstname.concat(' ' + this.lastname),
        comment: queryValue,
        date: this.newDate,
        createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
      });
      this.queryInterface.executeQuery(this.parseService, "Enquiry", [
        { condition: "equalTo", field: "objectId", value: this.objectId },
      ]).then(result => {
        let results = result[0];
        results.set("queries", this.queryData);
        this.toastr.success('Queries Saved Successfully!!');
        results.save().then(res => {
        });
      });
    }
    else {
      this.toastr.error('Add queries!!');
    }
    this.queryForm.patchValue({
      queries: ''
    });
  }

  addRisk() {
    const createrProfile = this.currentUser.get('profile');
    const createrImg = createrProfile.get('profileImageInfo').url;
    let riskValue = this.riskForm.value.risk;
    if (riskValue != '') {
      this.riskData.unshift({
        name: this.firstname.concat(' ' + this.lastname),
        comment: riskValue,
        date: this.newDate,
        createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
      });
      this.queryInterface.executeQuery(this.parseService, "Enquiry", [
        { condition: "equalTo", field: "objectId", value: this.objectId },
      ]).then(result => {
        let results = result[0];
        results.set("risk", this.riskData);
        this.toastr.success('Risk Saved Successfully!!');
        results.save().then(res => {
        });
      });
    }
    else {
      this.toastr.error('Add risk!!');
    }
    this.riskForm.patchValue({
      risk: ''
    });
  }

  /*
 ** ==========================================================
 ** Get Client Details
 ** ==========================================================
 */
  getClient() {
    var clientName = [];
    const result = [];
    this.queryInterface.executeQuery(this.parseService, 'Client', [{ field: 'name', condition: 'descending' }]).then(results => {
      const jsonText = JSON.stringify(results);
      const clients = JSON.parse(jsonText);
      for (const client of clients) {
        clientName = client.companyInfo.firstName;
        this.clientList.push({
          id: client.objectId,
          name: clientName.concat(' ' + client.companyInfo.lastName)
        });
      }
    });
  }

  /*
   ** ==========================================================
   ** Filter
   ** ==========================================================
   */
  filterApply(from, to) {
    let fromDate = new Date(from);
    let toDate = to !== '' ? new Date(new Date(to).setHours(23, 59, 59)) : new Date(new Date().setHours(23, 59, 59));
    if (from == '') {
      this.toastr.warning('Please select the start date');
    } else {
      let filteredActivities = this.opportunityActivities.filter(x => new Date(x.createdDate) >= new Date(fromDate) && new Date(x.createdDate) <= new Date(toDate));
      this.activities = (filteredActivities).slice(0, 50);
    }
  }

  getMinDate(date) {
    return new Date(date);
  }

  clearFilter() {
    this.activities = (this.opportunityActivities).slice(0, 50);
  }

  nextPage(event) {
    let activity = this.opportunityActivities;
    let start = event.pageIndex * event.pageSize;
    this.activities = activity.slice(start, start + event.pageSize);
  }

  getVersion(event) {
    let assigneId = event.value
    let queryInstance = this.parseService.instance.Object.extend('EnquiryAction');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('profileId');
    query.include('enquiryId');
    query.equalTo('enquiryId', { __type: 'Pointer', className: 'Enquiry', objectId: this.objectId });
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: assigneId });
    query.find().then(results => {
      results.forEach(element => {
        let selectVersion = element.get('version')
        this.versionId = element.id
        this.versions.push({ value: this.versionId, viewValue: selectVersion });
      });
    });
  }

  async saveWon() {
    let enquiryWon = this.parseService.instance.Object.extend('EnquiryAction');
    let query = new this.parseService.instance.Query(enquiryWon);
    query.equalTo('objectId', this.versionId);
    await query.find().then(results => {
      let result = results[0]
      result.set('status', 'Won');
      result.save().then(res => {
        this.toastr.success('Closed-Won saved successfully!!')
        this.wonResult();
      });
      this.dialog.closeAll();
    });
  }

  wonResult() {
    let enquiry = this.parseService.instance.Object.extend('Enquiry');
    let queryInstance = new this.parseService.instance.Query(enquiry);
    queryInstance.equalTo('objectId', this.objectId);
    queryInstance.find().then(results => {
      let wonResult = results[0]
      wonResult.set('status', 'Closed-Won')
      wonResult.save().then(res => {
        this.toastr.success('won saved succesfully!!')
      });
    });
  }

  ClosedLostSave() {
    let enquiryClass = this.parseService.instance.Object.extend('Enquiry');
    let queryInstance = new this.parseService.instance.Query(enquiryClass);
    queryInstance.find().then(results => {
      results.forEach(res => {
        let status = res.get("status")
        res.set('status', 'Closed-Lost')
        res.save().then(rese => {
          this.toastr.success('Closed-Lost saved successfully!!')
        })
        this.dialog.closeAll();
      });
    });
  }


}

